// Mock data for S4 Homes Construction Website

export const heroStats = [
  { number: '1200+', label: 'Projects Completed' },
  { number: '15+', label: 'Cities' },
  { number: '2.5M+', label: 'Sq. Ft Built' },
  { number: '98%', label: 'On-Time Delivery' }
];

export const awards = [
  { name: 'IGBC Green House', logo: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f' },
  { name: 'Industry Excellence', logo: 'https://images.pexels.com/photos/834892/pexels-photo-834892.jpeg' },
  { name: 'Quality Certification', logo: 'https://images.pexels.com/photos/1109541/pexels-photo-1109541.jpeg' }
];

export const features = [
  {
    title: 'Timely Delivery',
    description: 'We ensure your dream home is completed on schedule with no delays.'
  },
  {
    title: 'Construction Guarantee',
    description: '10 years waterproofing warranty and structural guarantee.'
  },
  {
    title: 'No Hidden Charges',
    description: 'Transparent pricing with fixed costs. What you see is what you pay.'
  },
  {
    title: 'No Subcontracting',
    description: 'Our in-house team handles everything from start to finish.'
  }
];

export const services = [
  {
    id: 1,
    title: 'Tracking',
    subtitle: 'Ensuring Proper Monitoring',
    description: 'S4 Homes provides real-time updates on your home construction progress, ensuring better supervision, enhanced efficiency, and proactive issue identification throughout the entire construction lifecycle.',
    details: [
      'Monitor work progress, quality, and project schedules',
      'Access all documents, receipts, and tax invoices with a click',
      'Track drawings, upcoming tasks, and payment schedules effortlessly',
      'Major milestones clearly marked for progress assessment'
    ],
    image: 'https://images.pexels.com/photos/1109541/pexels-photo-1109541.jpeg'
  },
  {
    id: 2,
    title: 'Designs',
    subtitle: 'For a Stylish Living',
    description: 'Our skilled architects, designers, and planners bring vast experience and updated innovations to every project. From floor plans and elevations to the design of doors, windows, grills, and lighting, every detail reflects our expertise.',
    details: [
      'Personalized spaces blending your preferences with fresh ideas',
      'Diverse architectural styles and specialties',
      'Sustainability features matching your vision',
      'Modern-day practices ensuring future-ready homes'
    ],
    image: 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg'
  },
  {
    id: 3,
    title: 'Experience',
    subtitle: '10+ Years of Excellence',
    description: 'Our hands-on experience sets the stage for exceptional home building. With extensive expertise, we meet both your essential needs and professional standards, making us pioneers in the home construction industry.',
    details: [
      'Tackle challenging projects with innovative solutions',
      'Craft new ways in home construction',
      'Always aligned with customer demands',
      'Precision and reliability in every project'
    ],
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5'
  },
  {
    id: 4,
    title: 'Walkthrough',
    subtitle: 'Marks a New Era',
    description: 'Our advanced walkthroughs allow you to visualize every aspect of your dream home with precision. This immersive experience enables you to explore the design in detail, offering the sensation of being physically on-site.',
    details: [
      'Explore design with immersive reality',
      'Collaborate effectively with architects',
      'Review designs and make informed decisions early',
      'Suggest changes to floor plans before construction'
    ],
    image: 'https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg'
  }
];

export const workingSteps = [
  {
    step: '01',
    title: "Let's Get Started",
    description: 'Enquire and schedule an appointment with our experts to discuss your requirements. Through calls and meetings, our technical sales executives ensure no detail is overlooked.',
    points: [
      'Understanding construction requirements',
      'Defining client construction criteria',
      'Estimated quote provided'
    ],
    image: 'https://images.unsplash.com/photo-1587582423116-ec07293f0395'
  },
  {
    step: '02',
    title: 'Design Specification',
    description: 'Our excellent in-house team of architects initiate the design process. Our dedicated design team conceptualizes the plan, transforming your requirements into a detailed virtual blueprint.',
    points: [
      '3D architectural floor plan and elevation designs',
      'Vaastu compliant designs',
      'Multiple design iterations'
    ],
    image: 'https://images.pexels.com/photos/271667/pexels-photo-271667.jpeg'
  },
  {
    step: '03',
    title: 'Client Agreement',
    description: 'Once the design is approved, the costing is finalized. We sign the construction stamp paper agreement and finalize the schedule. Transparent, fixed-cost pricing guaranteed.',
    points: [
      'No subcontracting of any kind',
      'Commitment to transparency',
      'Fixed-cost pricing'
    ],
    image: 'https://images.pexels.com/photos/834892/pexels-photo-834892.jpeg'
  },
  {
    step: '04',
    title: 'Construction & Updates',
    description: 'Construction begins within 30-45 days following the contract signing. Our execution team ensures full transparency through monthly reviews and expert assistance in material selection.',
    points: [
      'Monitor progress through S4 Homes App',
      'Distinct communication at every step',
      'Monthly quality reviews'
    ],
    image: 'https://images.pexels.com/photos/1216544/pexels-photo-1216544.jpeg'
  },
  {
    step: '05',
    title: 'Site Visits',
    description: 'Regular site visits by architects, structural & MEP designers along with project managers ensure 100% satisfaction. We evaluate workmanship, materials, and adherence to safety standards.',
    points: [
      'Comprehensive site and material management',
      'Periodic visits by quality & safety teams',
      'Prompt issue addressing'
    ],
    image: 'https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg'
  },
  {
    step: '06',
    title: 'Completion & Handover',
    description: 'The ultimate project handover marks the successful completion of your home construction journey with us. The fully finished property is ready for transition to your joy.',
    points: [
      'Complete final inspection',
      'Handover kit provided',
      'Ongoing support and satisfaction assurance'
    ],
    image: 'https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f'
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    project: "Rajesh's Dream Home",
    location: 'Bangalore',
    area: '3500 sqft',
    floors: 'G+2',
    price: '₹85 Lakhs',
    image: 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg',
    videoThumb: 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg'
  },
  {
    id: 2,
    name: "Priya Sharma",
    project: "Priya's Modern Villa",
    location: 'Chennai',
    area: '4200 sqft',
    floors: 'G+2.5',
    price: '₹1.2 Crores',
    image: 'https://images.pexels.com/photos/1732414/pexels-photo-1732414.jpeg',
    videoThumb: 'https://images.pexels.com/photos/1732414/pexels-photo-1732414.jpeg'
  },
  {
    id: 3,
    name: "Amit Patel",
    project: "Amit's Family Home",
    location: 'Bangalore',
    area: '2800 sqft',
    floors: 'G+1.5',
    price: '₹62 Lakhs',
    image: 'https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg',
    videoThumb: 'https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg'
  }
];

export const completedProjects = [
  { id: 1, image: 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg', alt: 'Completed Project 1' },
  { id: 2, image: 'https://images.pexels.com/photos/1732414/pexels-photo-1732414.jpeg', alt: 'Completed Project 2' },
  { id: 3, image: 'https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg', alt: 'Completed Project 3' },
  { id: 4, image: 'https://images.pexels.com/photos/262367/pexels-photo-262367.jpeg', alt: 'Completed Project 4' },
  { id: 5, image: 'https://images.unsplash.com/photo-1587582423116-ec07293f0395', alt: 'Completed Project 5' },
  { id: 6, image: 'https://images.pexels.com/photos/1109541/pexels-photo-1109541.jpeg', alt: 'Completed Project 6' },
  { id: 7, image: 'https://images.pexels.com/photos/271667/pexels-photo-271667.jpeg', alt: 'Completed Project 7' },
  { id: 8, image: 'https://images.pexels.com/photos/834892/pexels-photo-834892.jpeg', alt: 'Completed Project 8' }
];

export const packages = [
  {
    id: 1,
    name: 'Essential',
    price: '1620',
    description: 'Perfect for first-time home builders',
    features: ['Basic designs', 'Standard materials', 'Essential amenities', '1 year warranty']
  },
  {
    id: 2,
    name: 'Premium',
    price: '1850',
    description: 'Enhanced quality and features',
    features: ['Premium designs', 'High-quality materials', 'Modern amenities', '5 years warranty'],
    popular: true
  },
  {
    id: 3,
    name: 'Luxurious',
    price: '2400',
    description: 'Ultimate luxury living experience',
    features: ['Custom designs', 'Premium imported materials', 'Luxury amenities', '10 years warranty']
  },
  {
    id: 4,
    name: 'Green Home',
    price: '1930',
    description: 'Eco-friendly sustainable construction',
    features: ['Sustainable designs', 'Eco-friendly materials', 'Energy efficient', '7 years warranty']
  },
  {
    id: 5,
    name: 'The One',
    price: '2895',
    description: 'The ultimate dream home package',
    features: ['Bespoke designs', 'Ultra-premium materials', 'Smart home integration', 'Lifetime support']
  }
];

export const brands = [
  { name: 'Ultratech Cement', logo: 'https://images.pexels.com/photos/1216544/pexels-photo-1216544.jpeg' },
  { name: 'Asian Paints', logo: 'https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg' },
  { name: 'JSW Steel', logo: 'https://images.pexels.com/photos/834892/pexels-photo-834892.jpeg' },
  { name: 'Kajaria Tiles', logo: 'https://images.pexels.com/photos/271667/pexels-photo-271667.jpeg' },
  { name: 'Dr. Fixit', logo: 'https://images.pexels.com/photos/1109541/pexels-photo-1109541.jpeg' },
  { name: 'ACC Cement', logo: 'https://images.unsplash.com/photo-1587582423116-ec07293f0395' }
];

export const faqs = [
  {
    question: 'What is the cost per square foot for building a house?',
    answer: 'S4 Homes offers construction packages from ₹1620 to ₹3000 per sq. ft., based on design, materials, and client requirements.'
  },
  {
    question: 'Is the costing final?',
    answer: 'The cost is open for negotiation and can increase or decrease depending on the specific needs and design of the home.'
  },
  {
    question: 'What costs are included?',
    answer: 'The package includes complete design services including architectural, MEP & structural drawings. Total civil construction with all finishing including paint & sanitary fixtures. Other ancillary services like soil tests, inspections & liaison for plan sanction.'
  },
  {
    question: 'Does S4 Homes charge taxes?',
    answer: 'Yes, applicable taxes such as GST are already included in the packages & nothing is charged additionally.'
  },
  {
    question: 'Any other additional charges?',
    answer: 'Additional charges could apply for customizations and upgrades as needed by clients.'
  },
  {
    question: 'What is the typical construction timeline?',
    answer: 'Construction typically begins within 30-45 days of contract signing. The complete timeline depends on the project size and complexity, but we ensure 98% on-time delivery.'
  }
];

export const mediaFeatures = [
  {
    title: 'Bangalore-based S4 Homes is helping build dream homes one step at a time',
    source: 'YourStory'
  },
  {
    title: 'Eco-friendly home saves 40K litres of water/year, stays naturally cool in summer',
    source: 'The Better India'
  },
  {
    title: 'S4 Homes Revenue Rises To 100Cr In FY 24-25',
    source: 'RealtyNXT'
  },
  {
    title: 'S4 Homes Delivers 50+ homes in just 2 months',
    source: 'Hindustan Metro'
  }
];

export const greenHomeFeatures = [
  {
    title: 'Good Perspective',
    description: 'Have good perspective and technical knowledge of green homes.'
  },
  {
    title: 'Energy Efficient',
    description: 'Make energy-efficient designs to minimize environmental impact.'
  },
  {
    title: 'Cost Efficient',
    description: 'Use eco-friendly materials to reduce long-term costs.'
  }
];